module.exports = window["core-js/modules/es.regexp.to-string.js"];